import { DevLog } from "@/helpers/consoleHelpers"
import { ref } from "vue"

const abortController = ref<AbortController|null>(null)

export function useAbortController() {
    if (!abortController.value) {
        abortController.value = new AbortController()
    }

    const abortRequests = () => {
        if (abortController.value) {
            abortController.value.abort()
        } else {
            DevLog.log("No abort controller instance found")
        }
    }

    const destroyController = () => {
        if (abortController.value) {
            abortController.value = null
        }
    }

    const getSignal = () => {
        if (abortController.value) {
            return abortController.value.signal
        }

        return new AbortController().signal
    }

    return { 
        abortRequests,
        destroyController,
        getSignal
    };
}